export default __webpack_public_path__ + "static/media/Flaticon.bc6ffd64.woff2";